import axios from "axios";
import React, { useEffect, useState } from "react";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from "react-accessible-accordion";
import { SERVER_URL } from "../../api/url";

const Faq = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    fetchFaq();
  }, []);

  const fetchFaq = async () => {
    setLoading(true);
  
    try {
      const response = await axios.get(`${SERVER_URL}/about/questions`);
      const fetchedData = response.data?.data || [];
      setData(fetchedData);
    } catch (err) {
      console.error(err);
     
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="accordion__wrapper1">
   
      
      <Accordion className="accordion" allowZeroExpanded={true}>
        {data.length !== 0 && !loading && (
          data.map((faq, index) => (
            <AccordionItem
              className="accordion-item"
              key={faq.id || index} // Using `id` from the fetched data, or index as fallback
              uuid={`faq-${index}`}
            >
              <AccordionItemHeading className="accordion-button">
                <AccordionItemButton className="card-link">
                  {faq.question}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel className="accordion-body">
                <p>{faq.answer}</p>
              </AccordionItemPanel>
            </AccordionItem>
          ))
        )}
      </Accordion>
    </div>
  );
};

export default Faq;
